import Logo from '@/components/template/Logo'
import Alert from '@/components/ui/Alert'
import SubscribeForm from './components/SubscribeForm'
import useTimeOutMessage from '@/utils/hooks/useTimeOutMessage'
import { useThemeStore } from '@/store/themeStore'
import { useState } from 'react'

export const SubscribeBase = () => {
    const [message, setMessage] = useTimeOutMessage()
    const [successEmail, setSuccessEmail] = useState<string | null>(null)
    const mode = useThemeStore((state) => state.mode)

    const handleSuccess = (email: string) => {
        setSuccessEmail(email)
    }

    return (
        <>
            <div className="mb-10 flex items-center gap-4">
                <Logo
                    type="streamline"
                    mode={mode}
                    imgClass=""
                    logoWidth={60}
                />
                <div>
                    <h2 className="mb-2">Coming Soon!</h2>
                    <p className="font-semibold heading-text">
                        We're launching soon. Get notified when we're ready!
                    </p>
                </div>
            </div>

            {message && (
                <Alert showIcon className="mb-4" type="danger">
                    <span className="break-all">{message}</span>
                </Alert>
            )}

            {successEmail ? (
                <Alert showIcon className="mb-4" type="success">
                    <div>
                        <p className="font-semibold mb-2">Thank you for subscribing!</p>
                        <p className="text-sm">
                            We'll send you an email at <strong>{successEmail}</strong> when the platform is available.
                        </p>
                    </div>
                </Alert>
            ) : (
                <>
                    <div className="mb-6">
                        <h3 className="text-lg font-bold mb-3">Why join the waitlist?</h3>
                        <ul className="space-y-2 text-sm">
                            <li className="flex items-start">
                                <span className="mr-2">✓</span>
                                <span>Be among the first to access MemoSlate</span>
                            </li>
                            <li className="flex items-start">
                                <span className="mr-2">✓</span>
                                <span>Get exclusive early access benefits</span>
                            </li>
                            <li className="flex items-start">
                                <span className="mr-2">✓</span>
                                <span>Receive updates on our launch progress</span>
                            </li>
                        </ul>
                    </div>

                    <SubscribeForm onSuccess={handleSuccess} />
                </>
            )}
        </>
    )
}

const Subscribe = () => {
    return <SubscribeBase />
}

export default Subscribe

